import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import '@bingads-webui/kendo/kendo.data';
import { EndDateColumn as EndDateColumnConfig } from '@bingads-webui-campaign/ad-groups-data';
import { DateInlineEditableColumnPrompt } from '@bingads-webui-campaign/date-inline-edit-prompt';
import { convertUTCDateToMachineDate, displayDate } from '@bingads-webui-campaign/summary-grid-helper';
import { InlineEditableSave } from './inline-editable/save';
import dateTemplate from './date.pug';

export class EndDateColumn extends CampaignuiBaseColumn {
  constructor({ i18n, view, isForVNext }) {
    const title = i18n.getString('ColumnName_EndDate');

    super({
      ...EndDateColumnConfig,
      title,
      editable: true,
      enableEdit: item => !item.Campaign?.UseCampaignLevelDates,
      sortable: 'EndDate',
      type: 'string',
      helpId: 'pop_BA_CampaignsEndDate',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
    this.i18n = i18n;
    this.view = view;
    this.isForVNext = isForVNext;
  }

  pickProperty(item) {
    return {
      date: this.getEndDate(item),
      useCampaignLevelDates: item.Campaign?.UseCampaignLevelDates,
    };
  }

  getEndDate(item) {
    if (item.$total) {
      return '';
    }

    return item.Campaign?.UseCampaignLevelDates
      ? this.displayEndDate(item.Campaign.EndDate)
      : this.displayEndDate(item.EndDate);
  }

  displayEndDate(endDate) {
    return displayDate(endDate, 'EndDate_None', this.i18n);
  }

  onPrompt({ position, item, newPosition }) {
    const groupClass = `grid-group-${_.result(this.config, 'group', 'other')}`;
    const options = {
      position: this.isForVNext ? newPosition : position,
      isForVNext: this.isForVNext,
      item,
      view: this.view,
      i18n: this.i18n,
      fieldName: 'EndDate',
      allowNoDate: true,
      minDate: convertUTCDateToMachineDate(new Date(item.StartDate), this.i18n),
      customClass: groupClass,
      updater: InlineEditableSave,
    };

    if (item.EndDate) {
      options.selectedDate = convertUTCDateToMachineDate(new Date(item.EndDate), this.i18n);
    }
    return DateInlineEditableColumnPrompt(options);
  }

  template({ value }) {
    return dateTemplate(value);
  }
}
